import { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import AlertBanner from "../../DesignSystem/AlertBanner/AlertBanner";
import { auth } from "../../../backend/firebaseConfig";
import {
  getHelpfulContacts,
  saveHelpfulContacts,
} from "../services/helpfulContactsService";
import { DEFAULT_HELPFUL_CONTACTS } from "./constants/helpfulContacts";
import "../../../css/Adviser/LicenseCertificatesSummary.css";
import "../../../css/Recruitment/ReferenceEmailPreviewModal.css";

const HelpfulContactsModal = ({ open, onClose }) => {
  const [contacts, setContacts] = useState(DEFAULT_HELPFUL_CONTACTS);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    if (!open) return undefined;

    let active = true;
    setLoadError(false);
    getHelpfulContacts()
      .then(async (storedContacts) => {
        if (storedContacts === null) {
          await saveHelpfulContacts(
            DEFAULT_HELPFUL_CONTACTS,
            auth.currentUser?.email,
          );
          return;
        }
        if (active) setContacts(storedContacts);
      })
      .catch(() => {
        if (active) setLoadError(true);
      });

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      active = false;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="reference-email-modal-overlay" role="presentation">
      <section
        className="reference-email-modal gap-m bg-white p-m card-corner-radius"
        role="dialog"
        aria-modal="true"
        aria-labelledby="helpful-contacts-title"
      >
        <header className="reference-email-modal-header row-space-between gap-m">
          <h2 id="helpful-contacts-title" className="FP_Subtitle_Semibold text-primary-1">
            Helpful contact details
          </h2>
        
            <CloseIcon    onClick={onClose}/>
        
        </header>

        <div className="reference-email-modal-content">
          {loadError && (
            <AlertBanner type="info" message="The saved contact directory could not be loaded. The standard contact list is shown below." showClose={false} />
          )}
          <div className="lcTableWrap">
            <table className="lcTable" aria-label="Helpful contact details">
              <thead>
                <tr>
                  {['Organisation', 'Email', 'Notes'].map((heading) => (
                    <th key={heading}>
                      <div className="ParaplanningTableHeaderButton">
                        <span className="FP_Help_Text_Semibold">{heading}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {contacts.map((contact) => (
                  <tr key={contact.id || `${contact.organisation}-${contact.email}`}>
                    <td className="lcWrappedCell">
                      <span className="FP_Help_Text_Semibold black-text">{contact.organisation}</span>
                    </td>
                    <td className="lcWrappedCell">
                      <a className="FP_Help_Text table-url-link" href={`mailto:${contact.email}`}>{contact.email}</a>
                    </td>
                    <td className="lcWrappedCell">
                      <span className="FP_Help_Text black-text">{contact.notes || "-"}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HelpfulContactsModal;
